let r_allow = /\^/g;
export default {
  install(Vue) {
    // 下拉级联的值是多级串联，某些情况只显示最后一级
    Vue.filter("splitArrow", (v, char) => {
      return v.replace(r_allow, char);
    });
  }
};
